<template>
  <div class="customerAcountDetail">
    <div class="content">
      <div class="back" @click="goBack">
        <md-icon name="arrow-left" size="xs" style="font-size: 0.24rem;"></md-icon>
        <span>返回</span>
      </div>
      <div class="tl">
        <div class="left">
          <span>{{sum.good_name}}</span>
          <span>
            商品金额共
            <span>{{sum.goods_total_price_sum*1}}</span>元
          </span>
          <span class="discount">
            (
            <span>
              其中
              <span v-if="sum.discount_sum<=0">订单优惠{{Math.abs(sum.discount_sum*1)}}</span>
              <span v-else>订单多收{{sum.discount_sum*1}}</span>
              元
            </span>)
          </span>
          <span>，{{sum.count}}单</span>
        </div>
        <div class="time">
          <Calendar v-model="data_picker" @change="changeTime"></Calendar>
        </div>
      </div>
      <div class="listBox" v-if="list.length>0">
        <div class="title">
          <span>序号</span>
          <span>结算时间</span>
          <span>数量|重量</span>
          <span>价格</span>
          <span>商品金额</span>
          <span>买家</span>
          <span>收银员</span>
          <span></span>
        </div>
        <div class="detailBox">
          <md-scroll-view
            ref="scrollView"
            :auto-reflow="false"
            :bouncing="true"
            :scrolling-x="false"
            @end-reached="$_onEndReached"
          >
            <div
              v-for="(item,index) in list"
              :key="index"
              class="list"
              @click="lookDetail(item.order_sn)"
            >
              <span>{{index+1}}</span>
              <span>{{item.create_time}}</span>
              <span>
                <span>
                  <span v-if="item.bale!=3">{{item.num*1}}{{unit_list[item.num_unit-1].name}} |</span>
                  {{item.weight*1}}公斤
                </span>
              </span>
              <span>
                <span
                  v-if="item.bale!=3"
                >{{item.price_unit*1}}元/{{unit_list[item.num_unit-1].name}}|</span>
                {{item.price_weight*1}}元/公斤
              </span>
              <span>{{item.goods_total_price*1}}元</span>
              <span>{{item.name}}</span>
              <span>{{item.realname}}</span>
              <span>
                <md-icon name="arrow-right" size="sm"></md-icon>
              </span>
            </div>
            <md-scroll-view-more
              :finished-text="list.length>0?'全部已加载':'暂无数据'"
              slot="more"
              :is-finished="isFinished"
            ></md-scroll-view-more>
          </md-scroll-view>
        </div>
      </div>
      <div v-if="list.length==0" style="text-align:center;color:#999">暂无数据~</div>
    </div>
    <!-- 订单详情 -->
    <orderDetail
      :pop_show="isPopupShow"
      :orderId="orderId"
      @cancel="isPopupShow=false;orderId = ''"
    />
  </div>
</template>
<script>
import { Batch_Acount_GoodsDetail } from "@/api/work/acount/salesAcount";
import orderDetail from "../../order/orderDetail";
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import Calendar from "@/components/Calendar";
export default {
  name: "customerAcountDetail",
  components: {
    orderDetail,
    Calendar,
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" },
      ],
      dataQuery: {
        batch: "",
        s: "",
        e: "",
        orderby: "",
        desc: "",
        page: 1,
        pagesize: 55,
      },
      sum: {
        goods_total_price_sum: "",
        count: "",
        discount_sum: "",
        good_name: "",
      },
      data_picker: [],
      list: [],
      isPopupShow: false, //是否显示右边详情
      orderId: "",
    };
  },
  created() {
    this.dataQuery.batch = this.$route.query.batch;
    if (this.$route.query.s) {
      this.dataQuery.s = this.$route.query.s;
      this.dataQuery.e = this.$route.query.e;
      this.data_picker[0] = new Date(this.$route.query.s).getTime() / 1000;
      this.data_picker[1] = new Date(this.$route.query.e).getTime() / 1000;
    }
    this.getList();
  },
  mounted() {},
  methods: {
    //返回上一级
    goBack() {
      this.$router.go(-1);
    },
    getList() {
      if (this.dataQuery.page == 1) {
        this.list = [];
      }
      Batch_Acount_GoodsDetail(this.dataQuery).then((res) => {
        if (res.code == 200) {
          this.sum.goods_total_price_sum = res.data.goods_total_price_sum;
          this.sum.count = res.data.count;
          this.sum.discount_sum = res.data.discount_sum;
          this.sum.good_name = res.data.good_name;
          this.list = this.list.concat(res.data.list);
          if (
            this.list.length == res.data.totalCount ||
            res.data.list.length == 0
          ) {
            this.isFinished = true;
          } else {
            this.isFinished = false;
            this.dataQuery.page++;
          }
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.dataQuery.s = timestampToDate(this.data_picker[0]);
        this.dataQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.dataQuery.s = "";
        this.dataQuery.e = "";
      }
      this.dataQuery.page = 1;
      this.list = [];
      this.getList();
    },
    //查看详情
    lookDetail(order_sn) {
      if (order_sn) {
        this.orderId = order_sn;
        this.isPopupShow = true;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.customerAcountDetail {
  padding: 0.1rem;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 0;
  .content {
    padding: 0.2rem;
    background: #fff;
    border-radius: 0.1rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    height: 100%;
    .back {
      margin-bottom: 0.26rem;
      color: #31b158;
      font-weight: bold;
      font-size: 0.24rem;
      height: 0.32rem;
    }
    .tl {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.32rem;
      margin: 0 0.22rem;
      .left {
        display: flex;
        align-items: center;
        span {
          font-size: 0.22rem;
          color: #404040;
        }
        >span:nth-of-type(1){
          max-width: 2.8rem;
          text-overflow:ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        > span:nth-of-type(2) {
          margin-left: 0.12rem;
          > span {
            color: #31b158;
          }
        }
        .discount {
          font-size: 0.2rem;
          color: #999999;
          font-weight: normal;
          span {
            color: #999999;
            font-size: 0.2rem;
            font-weight: normal;
          }
        }
      }
    }
    .listBox {
      margin: 0 0.22rem;
      margin-top: 0.12rem;
      height: calc(100% - 0.32rem - 0.32rem - 0.26rem);
      .title {
        height: 0.68rem;
        border-top: 0.01rem solid #e5e5e5;
        border-bottom: 0.01rem solid #e5e5e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 0.22rem;
          color: #555;
          font-weight: bold;
          text-align: center;
          text-overflow: clip;
          white-space: nowrap;
          overflow: hidden;
        }
        span:nth-of-type(1) {
          width: 0.6rem;
        }
        span:nth-of-type(2) {
          width: 2rem;
        }
        span:nth-of-type(3) {
          width: 2.2rem;
        }
        span:nth-of-type(4) {
          width: 3rem;
        }
        span:nth-of-type(5) {
          width: 1.4rem;
        }
        span:nth-of-type(6) {
          width: 1rem;
        }
        span:nth-of-type(7) {
          width: 1rem;
        }
        span:nth-of-type(8) {
          width: 0.4rem;
        }
      }
      .detailBox {
        height: calc(100% - 0.68rem);
        font-size: 0.18rem;
        .list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 0.6rem;
          border-bottom: 0.01rem solid #e5e5e5;
          > span {
            text-align: center;
            color: #666666;
          }
          span:nth-of-type(1) {
            width: 0.6rem;
          }

          span:nth-of-type(2) {
            width: 2rem;
          }
          span:nth-of-type(3) {
            width: 2.2rem;
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(4) {
            width: 3rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(5) {
            width: 1.4rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(6) {
            width: 1rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          span:nth-of-type(7) {
            width: 1rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }

          span:nth-of-type(8) {
            width: 0.4rem;
            font-size: 0.22rem;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>